/* eslint-disable no-case-declarations */
/* eslint-disable no-underscore-dangle */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { ConcurrentsTypes, ConcurrentsState } from './types';

const INITIAL_STATE: ConcurrentsState = {
  concurrents: {
    view_panel: 'company',
    cnpj: '',
    company: [],
    sanctions: [],
    apf: [],
    penalties_sp: '',
    followups: [],
    total_followup: 1,
    total_results: 1,
    total_pages_sanctions: 1,
    results: [],
    sanctions_list: [],
    membership: [],
    itens_vencidos: {
      total: 0,
      licitacoes: [],
      estados: {},
      modalidades: {},
    },
    strategic_aspects: {
      desclassificacoes: 0,
      inabilitacoes: 0,
      total_participacoes: 0,
      percentuais: { desclassificacoes: 0, inabilitacoes: 0 },
      motivos: [],
    },
  },
  request: {
    company: {
      loading: false,
      loaded: false,
      error: false,
    },
    sanctions: {
      loading: false,
      loaded: false,
      error: false,
    },
    get_apf: {
      loading: false,
      loaded: false,
      error: false,
    },
    get_penalties_sp: {
      loading: false,
      loaded: false,
      error: false,
    },
    get_followups: {
      loading: false,
      loaded: false,
      error: false,
    },
    bidding_list: {
      loading: false,
      loaded: false,
      error: false,
    },
    sanctions_list: {
      loading: false,
      loaded: false,
      error: false,
    },
    membership_company: {
      loading: false,
      loaded: false,
      error: false,
    },
    itens_vencidos: {
      loading: false,
      loaded: false,
      error: false,
    },
    strategic_aspects: {
      loading: false,
      loaded: false,
      error: false,
    },
    participacoes_resumo: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};

const reducer: Reducer<ConcurrentsState> = (
  state = INITIAL_STATE,
  { type, page, result, cnpj },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case ConcurrentsTypes.SHOW_PAGE:
        draft.concurrents.view_panel = page;
        draft.concurrents.cnpj = cnpj;
        break;
      case ConcurrentsTypes.GET_COMPANY_REQUEST:
        draft.request.company = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_COMPANY_SUCCESS:
        draft.concurrents.company = Array(result?.data?.company);
        draft.request.company = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_COMPANY_FAILURE:
        draft.request.company = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConcurrentsTypes.GET_PENALTIES_REQUEST:
        draft.request.sanctions = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_PENALTIES_SUCCESS:
        draft.concurrents.sanctions = result?.data?.sanctions?.data;
        draft.request.sanctions = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_PENALTIES_FAILURE:
        draft.request.sanctions = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConcurrentsTypes.GET_CERTIDOES_APF_REQUEST:
        draft.request.get_apf = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_CERTIDOES_APF_SUCCESS:
        draft.concurrents.apf = result?.data?.apf?.certidoes_apf?.certidoes;
        draft.request.get_apf = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_CERTIDOES_APF_FAILURE:
        draft.request.get_apf = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConcurrentsTypes.GET_CERTIDOES_SP_REQUEST:
        draft.request.get_penalties_sp = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_CERTIDOES_SP_SUCCESS:
        draft.concurrents.penalties_sp = result?.data?.response;
        draft.request.get_penalties_sp = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_CERTIDOES_SP_FAILURE:
        draft.request.get_penalties_sp = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConcurrentsTypes.GET_FOLLOWUP_REQUEST:
        draft.request.get_followups = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_FOLLOWUP_SUCCESS:
        draft.concurrents.followups = result?.data?.biddings;
        draft.concurrents.total_followup = result?.data?.total_records;
        draft.request.get_followups = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_FOLLOWUP_FAILURE:
        draft.request.get_followups = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConcurrentsTypes.GET_BIDDINGS_REQUEST:
        draft.request.bidding_list = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_BIDDINGS_SUCCESS:
        draft.concurrents.total_results = result?.data?.results?.hits?.total?.value;
        draft.concurrents.results = result?.data?.results?.hits?.hits.map(
          (bidding: any) => bidding._source,
        );

        draft.request.bidding_list = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_BIDDINGS_FAILURE:
        draft.request.bidding_list = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConcurrentsTypes.GET_MEMBERSHIP_DATA_REQUEST:
        draft.concurrents.membership = INITIAL_STATE.concurrents.membership;
        draft.request.membership_company = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_MEMBERSHIP_DATA_SUCCESS:
        const companies = result?.data?.memberships;
        draft.concurrents.membership = companies;
        draft.request.membership_company = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_MEMBERSHIP_DATA_FAILURE:
        draft.concurrents.membership = INITIAL_STATE.concurrents.membership;
        draft.request.membership_company = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConcurrentsTypes.GET_SANCTIONS_LIST_REQUEST:
        draft.request.sanctions_list = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_SANCTIONS_LIST_SUCCESS:
        draft.concurrents.sanctions_list = result?.data?.sanctions;
        draft.concurrents.total_pages_sanctions = result?.data?.total_pages;
        draft.request.sanctions_list = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.GET_SANCTIONS_LIST_FAILURE:
        draft.request.sanctions_list = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConcurrentsTypes.ITENS_VENCIDOS_REQUEST:
        draft.request.itens_vencidos = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.ITENS_VENCIDOS_SUCCESS:
        draft.concurrents.itens_vencidos.licitacoes = result?.data?.licitacoes;
        draft.concurrents.itens_vencidos.total = result?.data?.total;
        draft.concurrents.itens_vencidos.estados = result?.data?.estados;
        draft.concurrents.itens_vencidos.modalidades = result?.data?.modalidades;
        draft.request.itens_vencidos = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.ITENS_VENCIDOS_FAILURE:
        draft.request.itens_vencidos = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ConcurrentsTypes.LIST_STRATEGIC_ASPECTS_REQUEST:
        draft.request.strategic_aspects = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.LIST_STRATEGIC_ASPECTS_SUCCESS:
        draft.concurrents.strategic_aspects = result?.data;
        draft.request.strategic_aspects = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.LIST_STRATEGIC_ASPECTS_FAILURE:
        draft.request.strategic_aspects = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ConcurrentsTypes.PARTICIPACOES_RESUMO_REQUEST:
        draft.request.participacoes_resumo = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ConcurrentsTypes.PARTICIPACOES_RESUMO_SUCCESS:
        draft.concurrents.participacoes_resumo = result?.data?.participacoes_resumo;
        draft.concurrents.participacoes_paginacao = result?.data?.paginacao;
        draft.request.participacoes_resumo = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ConcurrentsTypes.PARTICIPACOES_RESUMO_FAILURE:
        draft.request.participacoes_resumo = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ConcurrentsTypes.UPDATE_MEMBERSHIP:
        draft.concurrents.membership = [];
        break;
      default:
    }
  });
};
export default reducer;
